import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useAuth } from '../lib/auth'

export const Route = createFileRoute('/')({
  component: HomeRedirect,
})

/** Sends the user to the role-appropriate dashboard, or to /login if signed out. */
function HomeRedirect() {
  const navigate = useNavigate()
  const { role, session, loading } = useAuth()

  useEffect(() => {
    if (loading) return
    if (!session) {
      void navigate({ to: '/login' })
      return
    }
    switch (role) {
      case 'actor':
        void navigate({ to: '/actor' })
        return
      case 'supervisor':
        void navigate({ to: '/supervisor' })
        return
      case 'owner':
      case 'member':
        void navigate({ to: '/producer' })
        return
      default:
        // Signed in but no role yet (invitation half-completed) — send to account.
        void navigate({ to: '/account' })
    }
  }, [session, role, loading, navigate])

  return <p style={{ color: '#6b7280' }}>Redirecting...</p>
}
